const SESSION_DURATION_MS = 30 * 24 * 60 * 60 * 1000; // 30 days
const BACKGROUND_LOCK_THRESHOLD_MS = 4000; // ignore brief tab-switches / refreshes

export function createSession(username) {
  localStorage.setItem(
    "session_expires_at",
    String(Date.now() + SESSION_DURATION_MS),
  );
  if (username) localStorage.setItem("lgn_username", username);
  sessionStorage.setItem("pin_unlocked", "1");
}

export function clearSession() {
  localStorage.removeItem("token");
  localStorage.removeItem("type");
  localStorage.removeItem("session_expires_at");
  localStorage.removeItem("lgn_username");
  sessionStorage.removeItem("pin_unlocked");
  sessionStorage.removeItem("bg_at");
}

export function isSessionValid() {
  const token = localStorage.getItem("token");
  const expiresAt = Number(localStorage.getItem("session_expires_at") || 0);
  return !!token && expiresAt > Date.now();
}

export function isUnlocked() {
  return sessionStorage.getItem("pin_unlocked") === "1";
}

export function markUnlocked() {
  sessionStorage.setItem("pin_unlocked", "1");
}

export function markLocked() {
  sessionStorage.removeItem("pin_unlocked");
}

export function markBackgrounded() {
  sessionStorage.setItem("bg_at", String(Date.now()));
}

// Call when the app becomes visible again: if it was hidden long enough
// to look like the app was actually backgrounded (not just a refresh),
// drop the unlocked flag so the PIN gate re-engages.
export function checkResumeFromBackground() {
  const bgAt = Number(sessionStorage.getItem("bg_at") || 0);
  sessionStorage.removeItem("bg_at");
  if (bgAt && Date.now() - bgAt > BACKGROUND_LOCK_THRESHOLD_MS) {
    markLocked();
  }
}
